import React from 'react';
import { StyledImage } from './styled';

export const Image = ({ objectFit, ...props }) => {
    return <StyledImage $objectFit={objectFit} {...props} />;
};
